module.exports = __webpack_public_path__ + "img/confirm.33394223.png";